/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUserCard: {
  name: 'user-card';
  data: string;
} = {
  name: 'user-card',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H3Zm11.917 16H21V5H3v14h.083a6.002 6.002 0 0 1 11.834 0Zm-9.791 0a4.002 4.002 0 0 1 7.748 0H5.126ZM9 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm8 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm2 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z" fill="currentColor"/></svg>`,
};
